// The roles that exist to read what was shared with them. They have no exam
// pages and change nothing, in any account: a guest is outside the account, a
// reviewer is inside it, a subject is the worker the exam is about, and all
// three open an exam only through a share. This is the one list on this side;
// the server's is User::REPORT_ONLY_ROLES.
export const REPORT_ONLY_ROLES = ["guest_user", "reviewer", "subject"];

export const isReportOnlyRole = (role) => REPORT_ONLY_ROLES.includes(role);

// What a reviewer has beyond a guest: commenting on the exams shared with them,
// support, and the resources library. A guest only reads comments. A worker
// comments too, but has no support or resources. The server's counterparts are
// GuestAccess::COMMENTING_ROLES and REVIEWER_ALLOWED.
export const canComment = (role) => role !== "guest_user";
export const hasSupportAndResources = (role) => role !== "guest_user" && role !== "subject";

// A report-only person holds report-only memberships in every account they
// belong to and nothing else. They have no account of their own to choose, so
// they skip the account list and land on the shared-reports dashboard.
export const isReportOnly = (user) =>
  Array.isArray(user?.roles) &&
  user.roles.length > 0 &&
  user.roles.every((r) => isReportOnlyRole(r?.role_name));

export const REPORT_ONLY_HOME = "/shared-reports";

// A role's name as a person reads it: "uber_admin" -> "Uber Admin". Accepts the
// name or a { role_name } object — a role reaching the store as an object used
// to throw in the toolbar and take the whole app down with it, which is a lot
// of damage for a label. The one place a role becomes text: the role is stored
// as "subject", and everyone reads it as "Worker".
const ROLE_DISPLAY_NAMES = { subject: "Worker" };

export const roleLabel = (value) => {
  const name = typeof value === "string" ? value : value?.role_name;
  if (!name) return null;
  if (ROLE_DISPLAY_NAMES[name]) return ROLE_DISPLAY_NAMES[name];
  return name
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};
